import React, { useState, useEffect } from 'react';

const slides = [
  {
    imagen: "/imagenes/hero/1.jpeg",
    titulo: "Soluciones Industriales",
    texto: "Calidad y confianza"
  },
  {
    imagen: "/imagenes/hero/2.jpeg",
    titulo: "Filtración Profesional",
    texto: "Tecnología avanzada"
  },
  {
    imagen: "/imagenes/hero/3.jpeg",
    titulo: "Cobertura Nacional",
    texto: "Atención especializada"
  },
  {
    imagen: "/imagenes/hero/4.jpeg",
    titulo: "Equipo Certificado",
    texto: "Máxima confiabilidad"
  },
  {
    imagen: "/imagenes/hero/5.jpeg",
    titulo: "Servicio Empresarial",
    texto: "Compromiso total"
  }
];

const HeroCarousel = () => {
  const [slideActivo, setSlideActivo] = useState(0);

  useEffect(() => {
    const intervalo = setInterval(() => {
      setSlideActivo((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(intervalo);
  }, []);

  return (
    <section className="hero-carousel-section">
      <div className="hero-carousel-container">
        <img
          src={slides[slideActivo].imagen}
          alt={slides[slideActivo].titulo}
          className="hero-carousel-img"
        />

        <div className="hero-carousel-text">
          <h2>{slides[slideActivo].titulo}</h2>
          <p>{slides[slideActivo].texto}</p>
        </div>
      </div>
    </section>
  );
};

export default HeroCarousel;